import {t} from '../../../../common/getTranslations';
import {ContentHomeNoticeLineBanners} from '../../../../design-system/organisms/ContentHomeNoticeLineBanners/ContentHomeNoticeLineBanners';
import {ContentNoticeItem} from '../../../../design-system/organisms/ContentNoticeItem/ContentNoticeItem';
import {ContentTitleSection} from '../../../../design-system/organisms/ContentTitleSection/ContentTitleSection';
import {NoItem} from '../../../../design-system/organisms/NoItem/NoItem';
import {useInfiniteContentHomeNoticeQuery} from '../../../../wrapper/contentWrapper';
import {ContentHomeNoticeMobileMoreFetcherHeadless} from '../headless/ContentHomeNoticeMobileMoreFetcherHeadless';

export function ContentNoticeTabMobileListContainer({
  seriesId,
}: {
  seriesId: number;
}) {
  const data = useInfiniteContentHomeNoticeQuery(
    {
      contentHomeNoticeInput: {seriesId, page: 0},
    },
    {
      initialPageParam: {
        contentHomeNoticeInput: {seriesId, page: 0},
      },
      getNextPageParam: () => undefined,
    }
  ).data;
  const firstPageData = data?.pages[0].contentHomeNotice;

  const noItem =
    (!firstPageData?.noticeListContainer?.noticeList ||
      firstPageData?.noticeListContainer?.noticeList.length <= 0) &&
    !firstPageData?.topNotice;

  return (
    <>
      <ContentHomeNoticeLineBanners
        isMobile={true}
        lineBannerList={firstPageData?.lineBannerList}
      />
      <ContentTitleSection
        sectionTitle={undefined}
        isMobile={true}
        className="flex grow flex-col overflow-hidden"
      >
        {noItem && (
          <NoItem isMobile={true}>{t('contenthome_notice_tab_empty')}</NoItem>
        )}
        {!noItem && (
          <div className="flex flex-col space-y-8pxr px-11pxr pb-32pxr">
            {firstPageData?.topNotice && (
              <ContentNoticeItem
                type={firstPageData.topNotice.noticeType}
                isPinned={true}
                noticeTitle={firstPageData.topNotice.title}
                noticeDescription={firstPageData.topNotice.description}
                createDate={firstPageData.topNotice.createDate}
              />
            )}
            <ContentHomeNoticeMobileMoreFetcherHeadless seriesId={seriesId}>
              {data?.pages.map(group =>
                group.contentHomeNotice?.noticeListContainer?.noticeList.map(
                  notice => {
                    return (
                      <ContentNoticeItem
                        key={notice.id}
                        type={notice.noticeType}
                        isPinned={false}
                        noticeTitle={notice.title}
                        noticeDescription={notice.description}
                        createDate={notice.createDate}
                      />
                    );
                  }
                )
              )}
            </ContentHomeNoticeMobileMoreFetcherHeadless>
          </div>
        )}
      </ContentTitleSection>
    </>
  );
}
